"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Links = exports.StorageHelperTypes = exports.Cookies = exports.Regex = exports.ModalTypes = exports.Images = exports.Routes = void 0;
const helpers_1 = require("@/helpers");
const strings_1 = __importDefault(require("./strings"));
// Routes
exports.Routes = {
    // Generic
    Login: '/login',
    Home: '/',
    SignUp: '/signup',
    VerifyEmail: '/verify-email',
    VerifyEmailConfirm: '/verify-email-confirm',
    ResetPassword: '/reset-password',
    ResetPasswordChange: '/reset-password-change',
    ResetPasswordInstructions: '/reset-password-instructions',
    Subscriptions: '/subscriptions/',
    Subscribe: '/subscribe/',
    Profile: '/profile',
    WalletConnection: '/wallet-connection'
};
const getImagePath = (image) => STORYBOOK
    ? require(`../../../../backend/habitnest/static/images/${image}`).default // eslint-disable-line import/no-dynamic-require
    : (0, helpers_1.staticPath)(`/images/${image}`);
exports.Images = {
    searchIcon: getImagePath('search.png'),
    searchPressed: getImagePath('search-pressed.png'),
    success: getImagePath('check@2x.png'),
    triangle: getImagePath('triangle@2x.png'),
    error: getImagePath('red-close@2x.png'),
    logo: getImagePath('logo.png'),
    loginBackground: getImagePath('login-background.png'),
    signUpBackground: getImagePath('signup-background.png'),
    blueClose: getImagePath('blue-close.svg'),
    bookmark: getImagePath('bookmark@2x.png'),
    bookmarkPressed: getImagePath('bookmark-pressed@2x.png'),
    bannerBellIcon: getImagePath('bell@3x.png'),
    bannerWarningIcon: getImagePath('warning@3x.png'),
    chevronRight: getImagePath('chevron-right@3x.png'),
    heart: getImagePath('heart@3x.png'),
    angleDown: getImagePath('angle-down@3x.png'),
    angleDownDisabled: getImagePath('angle-down-disabled@3x.png'),
    mail: getImagePath('mail@3x.png'),
    mailActive: getImagePath('mail-active@3x.png'),
    mailError: getImagePath('mail-error@3x.png'),
    eye: getImagePath('eye@3x.png'),
    eyeActive: getImagePath('eye-active@3x.png'),
    eyeError: getImagePath('eye-error@3x.png'),
    eyeClose: getImagePath('eye-close@3x.png'),
    eyeCloseActive: getImagePath('eye-close-active@3x.png'),
    eyeCloseError: getImagePath('eye-close-error@3x.png'),
    userCheck: getImagePath('user-check@3x.png'),
    userCheckActive: getImagePath('user-check-active@3x.png'),
    userCheckError: getImagePath('user-check-error@3x.png'),
    navLogo: getImagePath('nav-logo@3x.png'),
    checkRadio: getImagePath('checked.png'),
    cross: getImagePath('cross.png'),
    userPlaceholder: getImagePath('user.png'),
    user: getImagePath('user.svg'),
    creditCard: getImagePath('credit-card.svg'),
    apiError: getImagePath('banner-error.png'),
    close: getImagePath('close.png'),
    subscriptions: getImagePath('signing-document.svg'),
    walletConnection: getImagePath('crypto.png'),
    metamaskWallet: getImagePath('metamask.svg'),
    phantomWallet: getImagePath('phantom.png'),
    walletConnect: getImagePath('walletconnect.png'),
    crossmint: getImagePath('crossmint.png'),
    trust: getImagePath('trust.jpeg'),
    coinbase: getImagePath('coinbase.jpeg'),
};
exports.ModalTypes = {
    cancelSubscriptions: 'CANCEL_SUBSCRIPTION',
};
exports.Regex = {
    oneLower: /(?=.*[a-z])/,
    oneUpper: /(?=.*[A-Z])/,
    oneNumber: /.*[0-9].*/,
    oneSpecialChar: /(?=.*[~`!@#$%^&*()+=_\-{}[\]|:;"'?/<>,.])/,
};
exports.Cookies = { auth: 'auth', };
exports.StorageHelperTypes = {
    cookie: 'cookie',
    local: 'local',
};
exports.Links = {
    ToS: 'https://habitnest.com/pages/shipping-return-privacy-policies'
};
exports.default = strings_1.default;
